import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3f6fc4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "photo-counter"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdImage = _resolveComponent("AdImage")!

  return (_openBlock(), _createElementBlock("div", {
    class: "gallery-slider",
    onMouseover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showCounter && _ctx.showCounter(...args)))
  }, [
    (_ctx.images && _ctx.images.length > _ctx.imageLimitCount)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "slider-prev",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPrevious && _ctx.onPrevious(...args)), ["stop","prevent"]))
        }))
      : _createCommentVNode("", true),
    (_ctx.images && _ctx.images.length > _ctx.imageLimitCount)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "slider-next",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onNext && _ctx.onNext(...args)), ["stop","prevent"]))
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thumbs, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "estate-card__photo"
      }, [
        _createVNode(_component_AdImage, {
          file: item,
          adGuid: _ctx.adGuid,
          watermark: false,
          estateType: _ctx.estateType,
          estateSubType: _ctx.estateSubType,
          width: _ctx.width,
          height: _ctx.height,
          backgroundImage: false
        }, null, 8, ["file", "adGuid", "estateType", "estateSubType", "width", "height"])
      ]))
    }), 128)),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showPhotoCounter && _ctx.images && _ctx.images.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.photoCounter) + " / " + _toDisplayString(_ctx.images ? _ctx.images.length : 0), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 32))
}